import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { AdminActions } from 'redux/actions';
import { Layout } from 'components';
import { Select, Spin, Table } from 'antd';
import { Container, PrimaryButton } from 'utils';
import { Link } from 'react-router-dom';
import styled from '@emotion/styled';
import Papa from 'papaparse';
import FormItem from 'antd/lib/form/FormItem';
import { adminServices } from 'services';
import config from 'config';
import { Modal } from 'utils';
import { store } from 'react-notifications-component';

const { Option } = Select;

const TableWrapper = styled.div`
  padding: 50px 0;
`;

const Filter = styled.div`
  display: grid;
  gap: 10px;
  margin-top: 20px;
  grid-template-columns: repeat(5, 1fr);
  & > * {
    min-width: 0 !important;
    width: 100%;
  }
  @media (max-width: 1024px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
`;

const ActionButtons = styled.div`
  display: grid;
  gap: 10px;
  align-items: stretch;
  margin-top: 16px;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  & > * {
    min-width: 0 !important;
    width: 100%;
    margin-left: 0 !important;
  }
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
  }
`;

const perPage = 50;
const SMALL_SCREEN_BREAKPOINT = 768;
const durationArr = [
  {
    title: 'Previous 99 days',
    value: 'previous99',
    id: 1,
  },
  {
    title: 'Next 99 days',
    value: 'next99',
    id: 2,
  },
];
const RoundedWrapper = styled.div`
  .ant-select-selector {
    border-radius: 12px !important;
    min-height: 40px;
    padding: 4px 8px !important;
  }

  .ant-select-selection-item {
    border-radius: 8px !important;
    padding: 2px 8px !important;
  }
`;

const notification = {
  insert: 'top',
  container: 'top-right',
  animationIn: ['animate__animated animate__fadeIn'], // `animate.css v4` classes
  animationOut: ['animate__animated animate__fadeOut'], // `animate.css v4` classes
  dismiss: {
    duration: 5000,
    onScreen: true,
  },
};

export class AllProjects extends Component {
  state = {
    isEnabled: null, // Initial state
    isRecurring: null,
    showModal: false,
    showEmailModal: false,
    users_emails: false,
    users_emails_value: [],
    users_emails_selected: [], // only selected ones with updated status
    original_selected: [], // ✅ will contain original true emails from API
    users_email_anonymous_selected: [],
    original_anonymous_selected: [],
    searchQuery: '',
  };

  handleSearch = (e) => {
    const { getAllProjects } = this.props;

    const query = e.target.value;
    this.setState({ searchQuery: query });

    clearTimeout(this._searchTimeout);
    this._searchTimeout = setTimeout(() => {
      getAllProjects(perPage, 1, this.state.status, this.state.filter, query);
    }, 400);
  };

  handleClick = () => {
    this.setState(
      (prevState) => ({
        isEnabled: !prevState.isEnabled,
        checked: true,
      }),
      () => {
        this.callApi();
      }
    );
  };
  callApi = () => {
    const { isEnabled } = this.state;
    try {
      this.setState({ loading: true, error: null });
      const res = adminServices.getEnabled(isEnabled);
    } catch (error) { }
  };

  handleClick1 = () => {
    this.setState(
      (prevState) => ({
        isRecurring: !prevState.isRecurring,
        checked: true,
      }),
      () => {
        this.callApi1();
      }
    );
  };
  callApi1 = () => {
    const { isRecurring } = this.state;
    try {
      this.setState({ loading: true, error: null });
      const res = adminServices.getRecurring(isRecurring);
    } catch (error) { }
  };

  static propTypes = {
    projects: PropTypes.any.isRequired,
    getAllProjects: PropTypes.func.isRequired,
    loading: PropTypes.bool.isRequired,
  };
  componentDidMount() {
    const { getAllProjects } = this.props;
    getAllProjects(perPage, 1, null, null, null);
    this._getProjectUsersAPI();
    this._resizeListener = () => {
      this.setState({ isSmallScreen: window.innerWidth < SMALL_SCREEN_BREAKPOINT });
    };
    window.addEventListener('resize', this._resizeListener);
  }

  componentWillUnmount() {
    if (this._resizeListener) {
      window.removeEventListener('resize', this._resizeListener);
    }
  }

  async _getProjectUsersAPI() {
    try {
      const _data = await adminServices.getProjectUsers();
      const allUsers = _data.users_emails;

      const preSelected = allUsers
        .filter((u) => u.anonymous_status === true)
        .map((u) => ({ email: u.email, status: true }));

      const enable_email_anonymous_selected = allUsers
        .filter((u) => u.enable_email_anonymous === true)

      this.setState({
        users_emails: allUsers,
        users_emails_selected: preSelected,
        original_selected: preSelected, // ✅ store original ones
        users_email_anonymous_selected: enable_email_anonymous_selected,
        original_anonymous_selected: enable_email_anonymous_selected,
      });
    } catch (err) {
      console.log(err);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.state.isEnabled !== this.props.projects.paypal_check &&
      !this.state.checked
    )
      this.setState({
        isEnabled: this.props.projects.paypal_check,
      });
  }
  constructor(props) {
    super(props);
    this.onClickDropdown = this.onClickDropdown.bind(this);
    this.state = {
      isEnabled: true, // Initial state: button is enabled
    };
  }
  state = {
    status: null,
    page: 1,
    filter: null,
    isSmallScreen: typeof window !== 'undefined' && window.innerWidth < SMALL_SCREEN_BREAKPOINT,
  };
  handleDownloadCSV = (data) => {
    const { projects } = this.props;

    const csvData = Papa.unparse(data);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = 'wegen_project_stats.csv';
    link.click();
  };

  async getAllProjectCsv() {
    const { filter, page, status } = this.state;
    try {
      this.setState({ loading: true, error: null });
      const res = await adminServices.getAllAdminProjectsCsv(filter, status);
      const data = res?.projects?.projects?.map((item) => {
        const {
          funding_start_date,
          funding_end_date,
          funding_days,
          learned_about,
          ...rest
        } = item;
        return {
          ...rest,
          url: `${config.REACT_APP_URL}project/${item?.url}`,
        };
      });
      if (data?.length > 0) {
        this.handleDownloadCSV(data);
      }
    } catch (error) { }
  }
  onClickDropdown(v) {
    const { page, status, filter, searchQuery } = this.state;
    const filterValue = v;
    this.setState({ filter: filterValue });
    this.props.getAllProjects(perPage, page, status, filterValue, searchQuery);
  }
  handelCloseModal = () => {
    this.setState({ showModal: false });
  };
  handelCloseEmailModal = () => {
    this.setState({ showEmailModal: false });
  };

  handleChangeEmail = (selected) => {
    const selectedList = selected.map((email) => ({ email, status: true }));
    this.setState({ users_email_anonymous_selected: selectedList });
  };

  handleChange = (selected) => {
    const selectedList = selected.map((email) => ({ email, status: true }));
    this.setState({ users_emails_selected: selectedList });
  };

  submitEmail = async () => {
    const { users_email_anonymous_selected, original_anonymous_selected } = this.state;

    const newlySelected = users_email_anonymous_selected.filter(
      (u) => !original_anonymous_selected.some((o) => o.email === u.email)
    );

    const removedSelected = original_anonymous_selected.filter(
      (o) => !users_email_anonymous_selected.some((u) => u.email === o.email)
    );

    const fd = new FormData();

    newlySelected.forEach((u, i) => {
      fd.append(`user[${i}][email]`, u.email);
      fd.append(`user[${i}][status]`, 'true');
    });

    removedSelected.forEach((u, i) => {
      fd.append(`user[${newlySelected.length + i}][email]`, u.email);
      fd.append(`user[${newlySelected.length + i}][status]`, 'false');
    });
    await adminServices.postProjectUsersEmailsAnonymous(fd);
    this.setState({ showEmailModal: false });
    store.addNotification({
      ...notification,
      title: 'Danke!',
      type: 'success',
      message: 'Update erfolgreich.',
    });
    this._getProjectUsersAPI();
  };

  submit = async () => {
    const { users_emails_selected, original_selected } = this.state;

    // items user selected now but weren't before = TRUE changes
    const newlySelected = users_emails_selected.filter(
      (u) => !original_selected.some((o) => o.email === u.email)
    );

    // items that were selected before but user removed now = FALSE changes
    const removedSelected = original_selected.filter(
      (o) => !users_emails_selected.some((u) => u.email === o.email)
    );

    const fd = new FormData();

    // ✅ send newly selected as true
    newlySelected.forEach((u, i) => {
      fd.append(`user[${i}][email]`, u.email);
      fd.append(`user[${i}][status]`, 'true');
    });

    // ✅ send removed as false
    removedSelected.forEach((u, i) => {
      fd.append(`user[${newlySelected.length + i}][email]`, u.email);
      fd.append(`user[${newlySelected.length + i}][status]`, 'false');
    });
    await adminServices.postProjectUsersEmails(fd);
    this.setState({ showModal: false });
    store.addNotification({
      ...notification,
      title: 'Danke!',
      type: 'success',
      message: 'Update erfolgreich.',
    });
    this._getProjectUsersAPI();
  };

  render() {
    const { projects, loading, getAllProjects } = this.props;
    const { filter, isEnabled, isRecurring, users_emails, searchQuery } = this.state;
    const columns = [
      {
        title: 'Project name',
        dataIndex: 'title',
        key: 'title',
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
      },
      { title: 'goal', dataIndex: 'goal', key: 'goal' },
      { title: 'city', dataIndex: 'city', key: 'city' },
      {
        title: 'View',
        dataIndex: 'view',
        key: 'view',
        render: (text, record) => (
          <Link to={`/admin/view-project/${record.id}`}>View {record.id}</Link>
        ),
      },
      {
        title: 'Stripe',
        dataIndex: 'stripe_connect_id',
        key: 'stripe_connect_id',
      },
      {
        title: 'Donations',
        dataIndex: 'donations',
        key: 'donations',
        render: (text, record) => (
          <Link to={`/admin/view-donation-detail/${record.id}`}>
            View Donation
          </Link>
        ),
      },
    ];

    return (
      <Layout>
        <Container>
          <Filter>
            <PrimaryButton
              onClick={() => {
                this.setState({
                  status: null,
                  page: 1,
                });
                getAllProjects(perPage, 1, null, null, searchQuery);
              }}
            >
              All
            </PrimaryButton>
            <PrimaryButton
              onClick={() => {
                this.setState({
                  status: 'accepted',
                  page: 1,
                });
                getAllProjects(perPage, 1, 'accepted', filter, searchQuery);
              }}
            >
              accepted
            </PrimaryButton>
            <PrimaryButton
              onClick={() => {
                this.setState({
                  status: 'pending',
                  page: 1,
                });
                getAllProjects(perPage, 1, 'pending', filter, searchQuery);
              }}
            >
              pending
            </PrimaryButton>
            <PrimaryButton
              onClick={() => {
                this.setState({
                  status: 'declined',
                  page: 1,
                });
                getAllProjects(perPage, 1, 'declined', filter, searchQuery);
              }}
            >
              declined
            </PrimaryButton>
            <PrimaryButton
              onClick={() => {
                this.setState({
                  status: 'finished',
                  page: 1,
                });
                getAllProjects(perPage, 1, 'finished', filter, searchQuery);
              }}
            >
              Finished
            </PrimaryButton>
          </Filter>
          <ActionButtons>
              <PrimaryButton onClick={() => this.getAllProjectCsv()}>
                Download CSV
              </PrimaryButton>
              <PrimaryButton
                className={`${isEnabled ? 'true' : 'false'}`}
                onClick={this.handleClick}
              >
                {isEnabled ? 'Paypal Enabled' : 'Paypal Disabled'}
              </PrimaryButton>
              <PrimaryButton
                onClick={this.handleClick1}
              >
                {isRecurring ? 'Recurring Enabled' : 'Recurring Disabled'}
              </PrimaryButton>
              <PrimaryButton
                onClick={() => this.setState({ showModal: true })}
              >
                Select Users
              </PrimaryButton>
              <PrimaryButton
                onClick={() => this.setState({ showEmailModal: true })}
              >
                Select Names
              </PrimaryButton>
          </ActionButtons>

          <input
            placeholder="Search by title or ID"
            value={this.state.searchQuery}
            onChange={this.handleSearch}
            style={{ marginTop: '16px', padding: '8px', width: '100%', borderRadius: '8px', border: '1px solid #ccc' }}
          />
          
          <TableWrapper>
            <Table
              columns={columns}
              dataSource={projects?.projects}
              loading={loading}
              scroll={this.state.isSmallScreen ? { x: 'max-content', y: 'calc(100vh - 320px)' } : undefined}
              pagination={{
                total: projects.count,
                pageSize: perPage,
                hideOnSinglePage: true,
                current: this.state.page,
                onChange: (page) => {
                  this.setState({ page });
                  getAllProjects(perPage, page, this.state.status, filter, searchQuery);
                },
              }}
            />
          </TableWrapper>
          <Modal
            width={'30%'}
            showModal={this.state.showModal}
            handelCloseModal={this.handelCloseModal}
          >
            <FormItem
              name="category_ids"
              label="Choose Email"
              style={{ flexDirection: 'column' }}
            >
              <RoundedWrapper>
                <div style={{}}>
                  <Select
                    // defaultValue={this.def}
                    showSearch
                    value={this.state.users_emails_selected?.map(
                      (u) => u.email
                    )} // ✅ only email list
                    tokenSeparators={[',']}
                    placeholder="Wähle eine Email"
                    notFoundContent={
                      loading ? (
                        <Spin size="small" />
                      ) : (
                        <p>there is no result </p>
                      )
                    }
                    filterOption={true}
                    onChange={this.handleChange}
                    mode="multiple"
                    dropdownStyle={{ zIndex: '2002' }}
                    style={{
                      width: '100%',
                      borderRadius: '12px', // ✅ Rounded select
                    }}
                  >
                    {users_emails?.map((item) => (
                      <Option key={item.email} value={item.email}>
                        {item.email}
                      </Option>
                    ))}
                  </Select>
                  <PrimaryButton
                    style={{
                      marginTop: '10px',
                      marginBottom: '0px',
                      paddingTop: '6px',
                      paddingBottom: '6px',
                      minWidth: '100%',
                      maxWidth: '100%',
                      fontSize: '14px',
                    }}
                    onClick={() => this.submit()}
                  >
                    Submit
                  </PrimaryButton>
                </div>
              </RoundedWrapper>
            </FormItem>
          </Modal>
          <Modal
            width={'30%'}
            showModal={this.state.showEmailModal}
            handelCloseModal={this.handelCloseEmailModal}
          >
            <FormItem
              name="category_ids"
              label="Choose Email"
              style={{ flexDirection: 'column' }}
            >
              <RoundedWrapper>
                <div style={{}}>
                  <Select
                    showSearch
                    value={this.state.users_email_anonymous_selected?.map(
                      (u) => u.email
                    )}
                    tokenSeparators={[',']}
                    placeholder="Wähle eine Email"
                    notFoundContent={
                      loading ? (
                        <Spin size="small" />
                      ) : (
                        <p>there is no result </p>
                      )
                    }
                    filterOption={true}
                    onChange={this.handleChangeEmail}
                    mode="multiple"
                    dropdownStyle={{ zIndex: '2002' }}
                    style={{
                      width: '100%',
                      borderRadius: '12px',
                    }}
                  >
                    {users_emails?.map((item) => (
                      <Option key={item.email} value={item.email}>
                        {item.email}
                      </Option>
                    ))}
                  </Select>
                  <PrimaryButton
                    style={{
                      marginTop: '10px',
                      marginBottom: '0px',
                      paddingTop: '6px',
                      paddingBottom: '6px',
                      minWidth: '100%',
                      maxWidth: '100%',
                      fontSize: '14px',
                    }}
                    onClick={() => this.submitEmail()}
                  >
                    Submit
                  </PrimaryButton>
                </div>
              </RoundedWrapper>
            </FormItem>
          </Modal>
        </Container>
      </Layout>
    );
  }
}

const mapStateToProps = (state) => {
  const { projects, loading } = state.admin;
  return {
    projects,
    loading,
  };
};

const mapDispatchToProps = (dispatch) => ({
  getAllProjects: (perPage, page, status = null, filter, query = null) =>
    dispatch(AdminActions.getAllProjects(perPage, page, status, filter, query)),
});
export default connect(mapStateToProps, mapDispatchToProps)(AllProjects);
